<template>
  <div class="eu-flex-item eu-basis_12">
    <p class="emd-card-grid__line">
      <button
        class="emd-btn _type_link _color_info"
        @click="viewBoleto"
      >
        <span
          class="uil uil-invoice"
          transform="width-16"
        />
        {{ $t('charge.detail.payment-method.boleto.view-boleto') }}
      </button>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodBoletoUrl',

  props: {
    url: { required: true }
  },

  methods: {
    viewBoleto () {
      window.open(this.url, '_blank')
    }
  }
}
</script>
